/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useAnimations, useTexture } from "@react-three/drei";

import model from "./Residencia_V10.glb";
import escadaDiffuse from "./materiais/Escada_Diffuse.jpg";
import escadaMetallic from "./materiais/Escada_Metallic.jpg";
import casaDiffuse from "./materiais/Casa_Diffuse.jpg";
import sofaDiffuse from "./materiais/Sofa_Diffuse.jpg";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);
  const escadaDiffuseTexture = useTexture(escadaDiffuse);
  const escadaMetallicTexture = useTexture(escadaMetallic);
  const casaDiffuseTexture = useTexture(casaDiffuse);
  const sofaDiffuseTexture = useTexture(sofaDiffuse);

  useEffect(() => {
    // console.log(materials);
    materials.Luminarias.roughnessMap = null;
    materials.Luminarias.roughness = 0.4;

    materials.MesaCentro.roughness = 0.5;

    materials.Escada.roughnessMap = null;
    materials.Escada.roughness = 0.58;

    Object.entries(materials).forEach(([key, value]) => {
      value.envMapIntensity = props.envMapIntensity;
    });

    //mapas estao aplicados diretamente nas tags

    // materials.Escada.map = escadaDiffuseTexture;
    // materials.Escada.map.flipY = false;
    // materials.Escada.metalnessMap = escadaMetallicTexture;
    // materials.Escada.metalnessMap.flipY = false;

    // materials.Sofa.map = sofaDiffuseTexture;
    // materials.Sofa.map.flipY = false;

    // materials.Casa.map = casaDiffuseTexture;
    // materials.Casa.map.flipY = false;
  }, [materials, props.envMapIntensity]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Casa"
          geometry={nodes.Casa.geometry}
          material={materials.Casa}
          material-map={casaDiffuseTexture}
          material-map-flipY={false}
        />
        <group name="Vidro" position={[1.43, 3.59, -1.97]}>
          <mesh
            name="Plane007"
            geometry={nodes.Plane007.geometry}
            material={materials.Vidro}
          />
          <mesh
            name="Plane007_1"
            geometry={nodes.Plane007_1.geometry}
            material={materials.BordaVidro}
          />
        </group>
        <mesh
          name="Guardaroupa"
          geometry={nodes.Guardaroupa.geometry}
          material={materials.Guardaroupa}
          position={[-1.57, 2.65, -4.91]}
        />
        <mesh
          name="Cama"
          geometry={nodes.Cama.geometry}
          material={materials.Cama}
          position={[-1.55, 3.06, -2.94]}
        />
        <mesh
          name="CadeiraPipe"
          geometry={nodes.CadeiraPipe.geometry}
          material={materials.CadPipe}
          position={[0.68, 3.13, -2.72]}
          rotation={[0, -0.35, 0]}
        />
        <mesh
          name="Escada"
          geometry={nodes.Escada.geometry}
          material={materials.Escada}
          material-map={escadaDiffuseTexture}
          material-map-flipY={false}
          material-metalnessMap={escadaMetallicTexture}
          material-metalnessMap-flipY={false}
          position={[2.07, 0.14, -1.02]}
        />
        <mesh
          name="Banqueta1"
          geometry={nodes.Banqueta1.geometry}
          material={materials.Banqueta1}
          position={[-1.52, 0, -2.17]}
          rotation={[0, -0.13, 0]}
        />
        <mesh
          name="Luminarias"
          geometry={nodes.Luminarias.geometry}
          material={materials.Luminarias}
          position={[-1.67, 2.5, -2.82]}
        />
        <mesh
          name="Balcao"
          geometry={nodes.Balcao.geometry}
          material={materials.Balcao}
          position={[-2.32, 0, -2.81]}
        />
        <mesh
          name="Recipientes"
          geometry={nodes.Recipientes.geometry}
          material={materials.Recipientes}
          position={[0.41, 0.9, -2.87]}
        />
        <mesh
          name="Banqueta2"
          geometry={nodes.Banqueta2.geometry}
          material={materials.Banqueta2}
          position={[-0.85, 0, -2.21]}
          rotation={[0, 0.31, 0]}
        />
        <mesh
          name="ArmarioCozinha"
          geometry={nodes.ArmarioCozinha.geometry}
          material={materials.ArmarioCozinha}
          position={[-0.94, 0, -4.93]}
        />
        <mesh
          name="Sofa"
          geometry={nodes.Sofa.geometry}
          material={materials.Sofa}
          material-map={sofaDiffuseTexture}
          material-map-flipY={false}
          position={[-2.03, 0.01, -0.5]}
        />
        <mesh
          name="MesaCentro"
          geometry={nodes.MesaCentro.geometry}
          material={materials.MesaCentro}
          position={[-0.27, 0, -0.5]}
        />
        <group name="Lustre" position={[0, 3.85, 0.64]}>
          <mesh
            name="Mesh001"
            geometry={nodes.Mesh001.geometry}
            material={materials.AluminioPolido}
          />
          <mesh
            name="Mesh001_1"
            geometry={nodes.Mesh001_1.geometry}
            material={materials.LenteLuminaria}
          />
        </group>
        <mesh
          name="Tapete"
          geometry={nodes.Tapete.geometry}
          material={materials.TapeteBake}
          position={[-0.52, 0, -0.52]}
        />
        <mesh
          name="Sonex_Ripado"
          geometry={nodes.Sonex_Ripado.geometry}
          material={materials.SonexRipado}
          position={[-2.57, 3.39, -1.9]}
        />
        <mesh
          name="Painel_Sonex_Fiberwood"
          geometry={nodes.Painel_Sonex_Fiberwood.geometry}
          material={materials.PainelSonex}
          position={[-2.57, 2.95, -0.52]}
          rotation={[0, 0, -Math.PI / 2]}
        />
        <mesh
          name="Quadro"
          geometry={nodes.Quadro.geometry}
          material={materials.Quadro}
          position={[-0.42, 4.46, -4.93]}
        />
        <mesh
          name="Mesa"
          geometry={nodes.Mesa.geometry}
          material={materials.Mesa}
          position={[1.09, 2.65, -2.69]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
